



























import { defineComponent, ref } from '@vue/composition-api';
import sl from '@/serviceLocator';

export interface SpecialChar {
  character: string;
  label: string;
}

export default defineComponent({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const actions = sl.get('globalActions');

    const specialCharacters = ref<SpecialChar[]>([
      {
        character: '[',
        label: 'Damage',
      },
      {
        character: ']',
        label: 'Damage',
      },
      {
        character: '⸢',
        label: 'Partial Damage',
      },
      {
        character: '⸣',
        label: 'Partial Damage',
      },
      {
        character: '«',
        label: 'Superfluous',
      },
      {
        character: '»',
        label: 'Superfluous',
      },
      {
        character: '‹',
        label: 'Omitted',
      },
      {
        character: '›',
        label: 'Omitted',
      },
      {
        character: '{',
        label: 'Erasure',
      },
      {
        character: '}',
        label: 'Erasure',
      },
      {
        character: ':',
        label: 'Uninterpreted',
      },
      {
        character: ';',
        label: 'Phonetic Complement',
      },
      {
        character: '*',
        label: 'Written Over Erasure',
      },
      {
        character: '?',
        label: 'Uncertain',
      },
      {
        character: '/',
        label: 'Written Below the Line',
      },
      {
        character: '\\',
        label: 'Written Above the Line',
      },
      {
        character: '!',
        label: '! - Emended Reading, !! - Collated Reading',
      },
      {
        character: '"',
        label: 'Original Sign',
      },
      {
        character: "'",
        label: 'Alternate Sign',
      },
      {
        character: 'x',
        label: 'Broken Sign',
      },
      {
        character: '...',
        label: 'Broken Signs (Unknown number)',
      },
      {
        character: '|',
        label: 'Separator',
      },
    ]);

    const inputSpecialChar = (char: string) => {
      actions.inputSpecialChar(char);
    };

    return {
      specialCharacters,
      inputSpecialChar,
    };
  },
});
